import axios from "axios";
import authHeader from "./auth-header";
import IRole from "../types/role.type";

const API_URL = `${process.env.REACT_APP_SERVER_URL}/role`;

export const getById = (id: string) => {
  return axios.get(API_URL + "/" + id, { headers: authHeader() });
};

export const create = (guest: IRole) => {
  return axios.post(API_URL, guest, { headers: authHeader() });
};

export const update = (id: number, guest: IRole) => {
  return axios.put(API_URL + "/" + id, guest, { headers: authHeader() });
};

export const getRoles = (params: {}) => {
  return axios.get(API_URL, { params: params, headers: authHeader() });
};
